export default __webpack_public_path__ + "static/media/emoji-agenda.95130e8b.svg";